
import React, { Component } from 'react';
import { connect }          from 'react-redux';
import RenderTopoPag          from '../../../container/RenderTopoPag';
import { GetActionBg }      from '../../../actions/scopoAction';
import bg_home              from "../../../img/bg/bg_home.png";
import Feed_big             from "./feeds_big";
import Rancking_aluno       from "./feeds_rancking_aluno";
import Feed_badg            from "./feeds_badg";
import Feeds                from "./feeds";
import Mural                from "./mural";
import Circle               from "./circle";
import '../../../css/aluno/home/home.css';
import '../../../css/aluno/home/feed.css';
import '../../../css/aluno/home/feed-grid.css';
import '../../../css/aluno/home/feed-hex.css';
import '../../../css/aluno/home/feed-hex-label.css';
import '../../../css/aluno/home/feed-box.css';
import '../../../css/aluno/home/menu.css';

class home extends Component {

    componentWillMount() {
        this.props.GetActionBg(bg_home);
    }

    render() {
        return ( 
                    <div className="hud-middle-center active">
                    <RenderTopoPag menu1="Dados da Nave" menu2="Dados da Tripulação" titulo="Nave"/>
                    <footer className="hud-middle-center-footer"></footer>

                   <main className="hud-middle-center-content">
                  {this.props.checkSelect == null ? <Feeds/>: <Feed_badg/>}  
                  {this.props.checkSelect == null ? <Feed_big/>: <Rancking_aluno/>}  
                 
                    {/* <Mural/> */}
                    <Circle/>
                </main>

                    </div>
        );  
    }
}

function mapStateToProps(state){
  return {  session: state.auth.session,
            menu: state.configReducer.menu,
           checkSelect : state.scopoReducer.checkSelect
         }
}


export default connect(mapStateToProps, { GetActionBg})(home);





// WEBPACK FOOTER //
// ./src/components/aluno/home/home.js